module.exports = {
      id: "palo-bangla-usage",
      viewBox: "0 0 230 55",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#palo-bangla",
      toString: function () {
        return this.url;
      }
    }